const AboutCodeCribPageArray = [
  {
    img_url: "ai-powered-tech.png",
    about_head: "Code Plagiarism Detector",
    about_para:
      "Scan Your Code For Unintentional Plagiarism.",
  },
  {
    img_url: "sitecompare.png",
    about_head: "Sequence Matcher",
    about_para:
      "With the assistance of our detailed plagiarism analysis and score,we can quickly and precisely evaluate all instances of plagiarized content in your work ",
  },
  {
    img_url: "accuratereports.png",
    about_head: "Accurate Reports",
    about_para:
      "Provides the Similarity Percentage Score",
  },
  {
    img_url: "downloadreport.png",
    about_head: "Download and Share Similarity Reports",
    about_para:
      "Real time Report and Analysis",
  }
];

export default AboutCodeCribPageArray;
